import moment from 'moment';
import { stepChangesToYourJourneyTrawickLookup as expenseLookup } from './claimCodeMapper';

function mapToParentSection() {
  return {};
}

function mapToQuestionnaire(data, claimCode) {
  const questionnaire = [];
  const entries = Object.entries(data);
  const excludedEntries = ['lossInformationItemsTravelCancellation',
    'reasonForTripCancellation',
    'insuredsTravelCancellation',
    'travelSuppliersTripCancellationForAnyReason',
    'lossInformationItemsTripCancellationForAnyReason',
    'insuredsTripCancellationForAnyReason',
    'lossInformationItems',
    'insuredsForInterruption',
    'reasonsForTripInterruption',
    'travelSuppliersTravelInterruption',
    'delayInformationItems',
    'selectedClaimFor',
    'reasonsForDelay',
    'reasonsForMissedConnection',
    'missedConnectionInformationItems',

    'flightDetailsTravelCancellation',
    'flightDetailsTravelInterruption',
    'flightDetailsTravelDelay',
    'flightDetailsMissedConnection',

    'cruiseLineDetailsTravelCancellation',
    'cruiseLineDetailsTravelInterruption',
    'cruiseLineDetailsTravelDelay',
    'cruiseLineDetailsMissedConnection',

    'otherDetailsTravelCancellation',
    'otherDetailsTravelInterruption',
    'otherDetailsTravelDelay',
    'otherDetailsMissedConnection',
  ];
  entries.forEach(([property, value]) => {
    if (excludedEntries.indexOf(property) < 0) {
      questionnaire.push({
        question: `section11.${property}`,
        answer: value,
        claimTypeCode: claimCode,
      });
    }
  });
  return [...questionnaire];
}

function mapToExpenses(data) {
  const tripInterruptedExpenses = mapToTripInterruptionExpense(data);
  const tripCancellationExpenses = mapToTripCancellationExpense(data);
  const tripCancellationForReasonExpenses = mapToCancellationForReasonExpense(data);
  const tripDelayExpenses = mapToTripDelayExpense(data);
  const missedConnectionExpenses = mapToMissedConnectionExpense(data);
  return [...tripInterruptedExpenses, ...tripCancellationExpenses, ...tripCancellationForReasonExpenses, ...tripDelayExpenses, ...missedConnectionExpenses];
}

function mapToTripInterruptionExpense(data) {
  if (data.travelInterruption !== 'true' || data.lossInformationItems.length < 1) {
    return [];
  }
  const claimCode = expenseLookup.travelInterruption.claimCode;
  const expenses = [];

  data.lossInformationItems.forEach(
    (item) => {
      const expense = mapInterruptionItemExpense(item, data, claimCode);
      if (!!expense) {
        expenses.push(expense);
      }
      const reimburseExpense = mapReimbursement(item, data, claimCode);
      if (!!reimburseExpense) {
        expenses.push(reimburseExpense);
      }
    }
  );

  return expenses;
}

function mapToTripCancellationExpense(data) {
  if (data.tripCancellation !== 'true' || data.lossInformationItemsTravelCancellation.length < 1) {
    return [];
  }
  const claimCode = expenseLookup.tripCancellation.claimCode;
  const expenses = [];

  data.lossInformationItemsTravelCancellation.forEach(
    (item) => {
      const expense = mapCancellationItemExpense(item, data, claimCode);
      if (!!expense) {
        expenses.push(expense);
      }
      const reimburseExpense = mapReimbursement(item, data, claimCode);
      if (!!reimburseExpense) {
        expenses.push(reimburseExpense);
      }
    }
  );

  return expenses;
}

function mapToCancellationForReasonExpense(data) {
  if (data.tripCancellationForAnyReason !== 'true' || data.lossInformationItemsTripCancellationForAnyReason.length < 1) {
    return [];
  }
  const claimCode = expenseLookup.tripCancellationForAnyReason.claimCode;
  const expenses = [];

  data.lossInformationItemsTripCancellationForAnyReason.forEach(
    (item) => {
      const expense = mapCancellationForReasonItemExpense(item, data, claimCode);
      if (!!expense) {
        expenses.push(expense);
      }
      const reimburseExpense = mapReimbursement(item, data, claimCode);
      if (!!reimburseExpense) {
        expenses.push(reimburseExpense);
      }
    }
  );

  return expenses;
}

function mapToTripDelayExpense(data) {
  if (data.travelDelay !== 'true' || data.delayInformationItems.length < 1) {
    return [];
  }
  const claimCode = expenseLookup.travelDelay.claimCode;
  const expenses = [];

  data.delayInformationItems.forEach(
    (item) => {
      const expense = mapDelayItemExpense(item, data, claimCode);
      if (!!expense) {
        expenses.push(expense);
      }
      const reimburseExpense = mapReimbursementTDL(item, data, claimCode);
      if (!!reimburseExpense) {
        expenses.push(reimburseExpense);
      }
    }
  );

  return expenses;
}

function mapToMissedConnectionExpense(data) {
  if (data.missedConnection !== 'true' || data.missedConnectionInformationItems.length < 1) {
    return [];
  }
  const claimCode = expenseLookup.missedConnection.claimCode;
  const expenses = [];

  data.missedConnectionInformationItems.forEach(
    (item) => {
      const expense = mapMissedConnectionItemExpense(item, data, claimCode);
      if (!!expense) {
        expenses.push(expense);
      }
      const reimburseExpense = mapReimbursementTDL(item, data, claimCode);
      if (!!reimburseExpense) {
        expenses.push(reimburseExpense);
      }
    }
  );

  return expenses;
}

function mapInterruptionItemExpense(item, formData, claimCode) {
  return mapExpenseItem(item, formData.dateTripInterrupted, claimCode);
}

function mapCancellationItemExpense(item, formData, claimCode) {
  return mapExpenseItem(item, formData.dateTravelCancellation, claimCode);
}

function mapCancellationForReasonItemExpense(item, formData, claimCode) {
  return mapExpenseItem(item, formData.dateTripCancellationForAnyReason, claimCode);
}

function mapDelayItemExpense(item, formData, claimCode) {
  return mapExpenseItemTDL(item, item.dateOfLoss, claimCode);
}

function mapMissedConnectionItemExpense(item, formData, claimCode) {
  return mapExpenseItemTDL(item, item.dateOfLoss, claimCode);
}

function mapExpenseItem(item, itemDate, claimCode) {
  const selectedClaimForArray = item.selectedClaimFor ? (!Array.isArray(item.selectedClaimFor)) ? item.selectedClaimFor.toJS() : item.selectedClaimFor : [];
  const claimForInsuredIds = selectedClaimForArray.map((claimFor) => claimFor.policyRoleID);
  if (!item || !item.amountPaidLoss || !item.currentAmountPaidLoss) {
    return null;
  }
  return {
    shortDescription: `${item.companyNameLoss}`,
    dateOfExpense: itemDate,
    clientCost: item.amountPaidLoss,
    currency: item.currentAmountPaidLoss,
    rate: null,
    requestedAmount: null,
    claimTypeCode: claimCode,
    claimForInsuredIds,
    claimForInsureds: selectedClaimForArray,
  };
}

function mapReimbursement(item, formData, claimCode) {
  const selectedClaimForArray = item.selectedClaimFor ? (!Array.isArray(item.selectedClaimFor)) ? item.selectedClaimFor.toJS() : item.selectedClaimFor : [];
  const claimForInsuredIds = selectedClaimForArray.map((claimFor) => claimFor.policyRoleID);
  if (!item || !item.howMuchReceivedReimbursement || !item.currentReceivedReimbursement || item.haveYouReceivedReimbursement !== 'true') {
    return null;
  }
  return {
    shortDescription: `${item.fromWhomReceivedReimbursement} (Reimbursement)`,
    dateOfExpense: item.dateReimbursementReceived,
    clientCost: `${item.howMuchReceivedReimbursement * -1}`,
    currency: item.currentReceivedReimbursement,
    rate: null,
    requestedAmount: null,
    claimTypeCode: claimCode,
    claimForInsuredIds,
    claimForInsureds: selectedClaimForArray,
  };
}

function mapExpenseItemTDL(item, itemDate, claimCode) {
  const selectedClaimForArray = item.selectedClaimFor ? (!Array.isArray(item.selectedClaimFor)) ? item.selectedClaimFor.toJS() : item.selectedClaimFor : [];
  const claimForInsuredIds = selectedClaimForArray.map((claimFor) => claimFor.policyRoleID);
  if (!item || !item.amountPaidLoss || !item.currentAmountPaidLoss) {
    return null;
  }
  return {
    shortDescription: `${item.companyNameLoss}`,
    dateOfExpense: moment(),
    clientCost: item.amountPaidLoss,
    currency: item.currentAmountPaidLoss,
    rate: null,
    requestedAmount: null,
    claimTypeCode: claimCode,
    claimForInsuredIds,
    claimForInsureds: selectedClaimForArray,
  };
}

function mapReimbursementTDL(item, formData, claimCode) {
  const selectedClaimForArray = item.selectedClaimFor ? (!Array.isArray(item.selectedClaimFor)) ? item.selectedClaimFor.toJS() : item.selectedClaimFor : [];
  const claimForInsuredIds = selectedClaimForArray.map((claimFor) => claimFor.policyRoleID);
  if (!item || !item.howMuchReceivedReimbursement || !item.currentReceivedReimbursement || item.haveYouReceivedReimbursement !== 'true') {
    return null;
  }
  return {
    shortDescription: `${item.fromWhomReceivedReimbursement} (Reimbursement)`,
    dateOfExpense: moment(),
    clientCost: `${item.howMuchReceivedReimbursement * -1}`,
    currency: item.currentReceivedReimbursement,
    rate: null,
    requestedAmount: null,
    claimTypeCode: claimCode,
    claimForInsuredIds,
    claimForInsureds: selectedClaimForArray,
  };
}

export default {
  mapToParentSection,
  mapToQuestionnaire,
  mapToExpenses,
};



// WEBPACK FOOTER //
// ./app/containers/FastCover/dataMapper/stepChangesToYourJourneyDataMapper.js